export default "__VITE_ASSET__2e96c211__"